// eslint-disable-next-line import/prefer-default-export
export const INTEGRATIONS_PATH = '/settings/integrations';
export const SHOPIFY_PATH = '/shopify';
export const MAILCHIMP_PATH = '/mailchimp';
export const CONNECT = 'connect';
export const SETTINGS = 'settings';
export const SHOPIFY_SETTINGS = `${INTEGRATIONS_PATH}${SHOPIFY_PATH}/${SETTINGS}`;
